<template>
    <div class="outline-popup">
        <div class="right-left">
            <div class="right-left-title">
                <div class="right-left-title-empty"> </div>
                <div class="right-left-title-text">{{ $t('smartCity.Monitor.549773-0') }}</div>
                <img class="iconimg" @click="closePopup" src="../../assets/homeback/closePopup.png" alt="">
            </div>
            <div class="right-left-table">
                <table class="table">
                    <th class="right-left-table-th right-left-table-th1">{{ $t('smartCity.Monitor.549773-1') }}</th>
                    <th class="right-left-table-th right-left-table-th2">{{ $t('smartCity.Monitor.549773-2') }}</th>
                    <th class="right-left-table-th right-left-table-th3">{{ $t('smartCity.Monitor.549773-3') }}</th>
                    <th class="right-left-table-th right-left-table-th4">{{ $t('smartCity.Monitor.549773-4') }}</th>
                </table>
                <div class="right-left-table-content">
                    <div class="right-left-table-tr" v-for="(item, index) in Popuplist" :key="index" @click="ShowDetail(item)">
                        <div>{{item.Address}}</div>
                        <div>{{item.DeviceCode}}</div>
                        <div>{{item.UserDeviceName}}</div>
                        <div>{{item.IsOnline == 1 ? $t('smartCity.Monitor.549773-5') : $t('smartCity.Monitor.549773-6')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../api/request.js'
import Cookies from "js-cookie";
export default {
    props: {
        Popuplist: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            liveSrc: ''
        };
    },
    mounted() {},
    methods: {
        closePopup() {
            this.$emit("childEvent", false)
        },
        ShowDetail(item){
            if(!Cookies.get('AdminData')){
                return
            }
            let _this = this,
              AdminData = JSON.parse(Cookies.get('AdminData'))
            let deviceSerial = item.DeviceCode,
            validateCode = item.Mac
            api({
                method: 'get',
                url: `api/YhjDevice/GetYsDeviceMonitor?deviceSerial=${deviceSerial}&validateCode=${validateCode}`,
                data: {},
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            },'yhj').then(res=> {
                console.log(res.Data.LiveSrc,12333);
                _this.liveSrc = res.Data.LiveSrc
                window.open(_this.liveSrc, '_blank')
            })
        },
    }
}
</script>


<style scoped="scoped" lang="scss">
@import "./big_screen_default.scss";
@import "./big_screen.scss";
@import "./home_back1.scss";

.ifram_bgclo {
    background-color: #fff;
    width: 100vw;
    height: 100vh;
}
.outline-popup .right-left .right-left-table {
    margin-top: 20px;
    &-th1 {
        width: 30%;
    }
    &-th2 {
        width: 25%;
    }
    &-th3 {
        width: 25%;
    }
    &-th4 {
        width: 20%;
    }
    &-tr {
        margin-top: 10px;
        width: 100%;
        height: 36px;
        font-size: 14px;
        background: rgba(255, 255, 255, .22);
        border-radius: 4px;
        display: flex;
        align-items: center;

        >div {
            text-align: center;
        }

        :nth-child(1) {
            width: 30%;
        }

        :nth-child(2) {
            width: 25%;
        }

        :nth-child(3) {
            width: 25%;
        }

        :nth-child(4) {
            width: 20%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/smartCity/Monitor.vue